import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import AddTripInput from "../../Components/Admin/AddTripInput";

const AddTrip = () => {
  return (
    <>
      <Navbar />
      <AddTripInput />

      <Footer />
    </>
  );
};

export default AddTrip;
